import { Flex, Input, Text } from '@byecode/ui'
import React from 'react'
import styled from 'styled-components'

interface NameProps {
    value?: string
    label: string
    onChange?: (value: string) => void
}

const Name = React.forwardRef<HTMLDivElement, NameProps>(({ value = '注册', label, onChange }, ref) => {
    return (
        <Flex mt={4} px={8} style={{ height: 40 }} justifyContent="space-between" alignItems="center" ref={ref}>
            <Text>{label}</Text>
            <Input
                styles={{
                    wrapper: {
                        width: 180
                    }
                }}
                value={value}
                onChange={e => onChange?.(e.target.value)}
            />
        </Flex>
    )
})

export default React.memo(Name)
